import React, { Component } from 'react';
import './Parkinglot.css';

class Parkinglot extends Component {
  constructor(props) {
    super(props);
    this.state = {
     parkingjanhr: '8',
     parkingfebhr: '8',
     parkingmarhr: '8',
     parkingaprhr: '8',
     parkingmayhr: '8',
     parkingjunhr: '8',
     parkingjulhr: '8',
     parkingaughr: '8',
     parkingsephr: '8',
     parkingocthr: '8',
     parkingnovhr: '8',
     parkingdechr: '8'

    }
  }

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, );
  }

  render() {
    return (
      <div>
        <div>
          <div className="Calendar-Container">
            {/* occ hours*/}
            <div>
            <div className="occ-bold">Parking Lot Hours:</div>
              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingjanhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingjanhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingfebhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingfebhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingmarhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingmarhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingaprhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingaprhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingmayhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingmayhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingjunhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingjunhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingjulhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingjulhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingaughr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingaughr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingsephr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingsephr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingocthr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingocthr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingnovhr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingnovhr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

              <div className="park-form-group-hr">
                <div className="form-group">
                  <input type="number"
                    name="parkingdechr"
                    min="0"
                    max="24"
                    step="1"
                    value={this.state.parkingdechr}
                    onChange={this.handleUserInput}
                  />
                </div>
              </div>

            </div>
            {/*end  occhours */}

            
          </div>

        </div>
      </div>
    );
  }
}

export default Parkinglot;


// WEBPACK FOOTER //
// ./src/components/Parkinglot.js